var _g, _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCurrencyCzk(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1516_136732)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_1516_136732)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -8.00391,
    width: 46.1221,
    height: 30.6785,
    rx: 5.76455,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.1182 0H-8.00391V30.6785H38.1182V0Z",
    fill: "#D7141A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.1182 0H-8.00391V15.3393H38.1182V0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.0572 15.3393L-8.00391 0V30.6785L15.0572 15.3393Z",
    fill: "#11457E"
  })), /*#__PURE__*/React.createElement("rect", {
    x: -8.00391,
    width: 46.1221,
    height: 30.6785,
    rx: 5.76455,
    stroke: "#E5E5E5",
    strokeWidth: 1.44114,
    strokeLinejoin: "round"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 29,
    height: 29,
    rx: 14.5,
    stroke: "#E5E5E5"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1516_136732"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 28,
    height: 28,
    rx: 14,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_1516_136732"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -8.00391,
    width: 46.1221,
    height: 30.6785,
    rx: 5.76455,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCurrencyCzk);
export default __webpack_public_path__ + "static/media/Currency=CZK.7b3a14871cb9f33b5b8fcda0083c6c63.svg";
export { ForwardRef as ReactComponent };